import React from 'react';
import AdminMenuGrid from '../components/AdminMenuGrid';
import {
  Building2, Settings2, CalendarDays, Coins, Users, ArrowLeftRight,
  FileText, Monitor, UserCheck, Clock, CreditCard, Lock,
  FileEdit, Terminal, CheckSquare, Upload
} from 'lucide-react';

const OrganizationHubPage = () => {
  const items = [
    { label: 'Manage Offices', icon: Building2, path: '/dashboard/admin/organization/offices', id: 'offices' },
    { label: 'Currency Configuration', icon: Settings2, path: '/dashboard/admin/organization/currencies', id: 'currencies' },
    { label: 'Manage Holidays', icon: CalendarDays, path: '/dashboard/admin/organization/holidays', id: 'holidays' },
    { label: 'Manage Funds', icon: Coins, path: '/dashboard/admin/organization/funds', id: 'funds' },
    { label: 'Manage Employees', icon: Users, path: '/dashboard/admin/organization/employees', id: 'employees' },
    { label: 'Bulk Loan Reassignment', icon: ArrowLeftRight, path: '/dashboard/admin/organization/bulk-reassignment', id: 'bulk-reassignment' },
    { label: 'Standing Instructions History', icon: FileText, path: '/dashboard/admin/organization/standing-instructions', id: 'standing-instructions' },
    { label: 'Teller / Cashier Management', icon: Monitor, path: '/dashboard/admin/organization/tellers', id: 'tellers' },
    { label: 'Investors', icon: UserCheck, path: '/dashboard/admin/organization/investors', id: 'investors' },
    { label: 'Working Days', icon: Clock, path: '/dashboard/admin/organization/working-days', id: 'working-days' },
    { label: 'Fund Mapping', icon: ArrowLeftRight, path: '/dashboard/admin/organization/fund-mapping', id: 'fund-mapping' },
    { label: 'Payment Type', icon: CreditCard, path: '/dashboard/admin/organization/payment-types', id: 'payment-types' },
    { label: 'Password Preferences', icon: Lock, path: '/dashboard/admin/organization/password-preferences', id: 'password-preferences' },
    { label: 'SMS Campaigns', icon: FileText, path: '/dashboard/admin/organization/sms-campaigns', id: 'sms-campaigns' },
    { label: 'Loan Provisioning Criteria', icon: FileEdit, path: '/dashboard/admin/organization/loan-provisioning', id: 'loan-provisioning' },
    { label: 'AdHocQuery', icon: Terminal, path: '/dashboard/admin/organization/adhoc-query', id: 'adhoc-query' },
    { label: 'Entity Data Table Checks', icon: CheckSquare, path: '/dashboard/admin/organization/entity-checks', id: 'entity-checks' },
    { label: 'Bulk Import', icon: Upload, path: '/dashboard/admin/organization/bulk-import', id: 'bulk-import' },
  ];

  return <AdminMenuGrid title="Organization" breadcrumb={['Organization', 'Home / Organization']} items={items} />;
};

export default OrganizationHubPage;
